import history from 'history.js'
import firebaseService from 'firebaseService'
import jwtService from 'jwtService'
import axios from 'axios'
import bcryptjs from 'bcryptjs'
import { setUserData } from 'auth/store/actions/user.actions'
import * as Actions from 'store/actions'

export const LOGIN_ERROR = 'LOGIN_ERROR'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'

const fetchAvatar = (email) => {
  if (email === 's.foriero@mioassicuratore.it') {
    // return 'assets/images/avatars/sara.jpeg'
    return 'https://i.ebayimg.com/images/g/xDYAAOSwjMJXCLaE/s-l300.jpg'
  } else if (email === 'campagnano@mioassicuratore.it') {
    return 'assets/images/avatars/giorgio.jpeg'
  } else {
    // return 'assets/images/avatars/user.png'
    return 'https://i.ebayimg.com/images/g/xDYAAOSwjMJXCLaE/s-l300.jpg'
  }
}

const admins = [
  'campagnano@mioassicuratore.it',
  'rullo.mioassicuratore@gmail.com',
  'sorice.job@gmail.com',
  'a.ramundo@mioassicuratore.it',
  'e.giosue@mioassicuratore.it',
  's.foriero@mioassicuratore.it',
  'a.casertano@mioassicuratore.it']
const amministrazione = [
  'g.segatori@mioassicuratore.it',
  's.foriero@mioassicuratore.it',
  'd.salvo@mioassicuratore.it',
  'f.casale@mioassicuratore.it',
  'rullo.mioassicuratore@gmail.com'
]

const crmRuoli = {
  1: 'admin',
  2: 'sales',
  3: 'sales_emissione',
  4: 'rinnovi',
  5: 'rinnovi_emissione',
  6: 'sales_rinnovi_emissione',
  7: 'sales_external',
  8: 'inbound'
}

const crmPrivilegi = {
  1: 'full',
  2: 'limited',
  3: 'emissioni',
  4: 'minimal'
}

const permissions = privilege => ({
  'admin': {
    'all': privilege
  },
  'sales_emissione': {
    'utenti': privilege,
    'quotazioni': privilege,
    'richieste': privilege,
    'mandatari': privilege,
    'pagamenti': true
  },
  'sales': {
    'utenti': privilege,
    'mandatari': privilege
  },
  'rinnovi': {
    'utenti': privilege,
    'mandatari': privilege
  },
  'rinnovi_emissione': {
    'rinnovi': privilege,
    'scadenze': privilege,
    'utenti': privilege,
    'quotazioni': privilege,
    'richieste': privilege,
    'mandatari': privilege,
    'pagamenti': true
  },
  'sales_rinnovi_emissione': {
    'utenti': privilege,
    'quotazioni': privilege,
    'richieste': privilege,
    'rinnovi': privilege,
    'scadenze': privilege,
    'mandatari': privilege,
    'pagamenti': true
  },
  'inbound': {
    'utenti': privilege,
    'quotazioni': privilege,
    'richieste': privilege,
    'rinnovi': privilege,
    'scadenze': privilege,
    'mandatari': privilege,
    'pagamenti': true
  }
})

export function submitLoginSimple ({ username, password }) {
  return (dispatch) => {
    axios.post(`${process.env.REACT_APP_API_AUTH}/login/entita`, { username, password })
      .then(response => {
        const role = response.data.idCrmRuolo ? crmRuoli[response.data.idCrmRuolo] : 'admin'
        const privilegio = response.data.idCrmPrivilegio ? crmPrivilegi[response.data.idCrmPrivilegio] : 'full'
        console.log('RESPONSE', response.data)
        const user = {
          role,
          data: {
            'displayName': response.data.identificativo,
            'photoURL': fetchAvatar(response.data.email),
            'email': response.data.email,
            'id': response.data.id,
            permissions: role ? permissions(privilegio)[role] : null
          }
        }
        console.log('YUSER', user)

        if (response.data.idRuolo === 12) {
          return dispatch({
            type: LOGIN_ERROR,
            payload: 'Accesso non autorizzato'
          })
        }

        // JWT interceptor
        window.localStorage.setItem('token', response.data.token)
        axios.interceptors.request.use(async config => {
          config.headers['Authorization'] = `Bearer ${response.data.token}`
          return config
        }, (error) => {
          return Promise.reject(error)
        })

        window.localStorage.setItem('user', JSON.stringify(user))
        dispatch(setUserData(user))
        history.push('/')

        return dispatch({
          type: LOGIN_SUCCESS
        })
      })
      .catch(error => {
        return dispatch({
          type: LOGIN_ERROR,
          payload: error
        })
      })
  }
}

export function submitLoginJWT ({ email, password }) {
  return (dispatch) =>
    jwtService.signInWithEmailAndPassword(email, password)
      .then((user) => {
        dispatch(setUserData(user))

        return dispatch({
          type: LOGIN_SUCCESS
        })
      }
      )
      .catch(error => {
        return dispatch({
          type: LOGIN_ERROR,
          payload: error
        })
      })
}

export function submitLoginWithFireBase ({ username, password }) {
  return (dispatch) =>
    firebaseService.auth && firebaseService.auth.signInWithEmailAndPassword(username, password)
      .then(() => {
        return dispatch({
          type: LOGIN_SUCCESS
        })
      })
      .catch(error => {
        const usernameErrorCodes = [
          'auth/email-already-in-use',
          'auth/invalid-email',
          'auth/operation-not-allowed',
          'auth/user-not-found',
          'auth/user-disabled'
        ]
        const passwordErrorCodes = [
          'auth/weak-password',
          'auth/wrong-password'
        ]

        const response = {
          username: usernameErrorCodes.includes(error.code) ? error.message : null,
          password: passwordErrorCodes.includes(error.code) ? error.message : null
        }

        if (error.code === 'auth/invalid-api-key') {
          dispatch(Actions.showMessage({ message: error.message }))
        }

        return dispatch({
          type: LOGIN_ERROR,
          payload: response
        })
      })
}
